/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicCallbackRouteImport } from './routes/_public/callback'
import { Route as AuthUsernameRouteImport } from './routes/_auth/username'
import { Route as AuthPublicRouteImport } from './routes/_auth/public'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthDecksIndexRouteImport } from './routes/_auth/decks/index'
import { Route as PublicUUsernameRouteImport } from './routes/_public/u.$username'
import { Route as AuthTestDeckIdRouteImport } from './routes/_auth/test.$deckId'
import { Route as AuthStudyAllRouteImport } from './routes/_auth/study/all'
import { Route as AuthStudyDeckIdRouteImport } from './routes/_auth/study/$deckId'
import { Route as AuthSettingsProfileRouteImport } from './routes/_auth/settings/profile'
import { Route as AuthReviewDeckIdRouteImport } from './routes/_auth/review.$deckId'
import { Route as AuthDecksDeckIdRouteImport } from './routes/_auth/decks/$deckId'
import { Route as AuthDecksDeckIdPreviewRouteImport } from './routes/_auth/decks/$deckId_.preview'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCallbackRoute = PublicCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUsernameRoute = AuthUsernameRouteImport.update({
  id: '/username',
  path: '/username',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublicRoute = AuthPublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDecksIndexRoute = AuthDecksIndexRouteImport.update({
  id: '/decks/',
  path: '/decks/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicUUsernameRoute = PublicUUsernameRouteImport.update({
  id: '/u/$username',
  path: '/u/$username',
  getParentRoute: () => PublicRoute,
} as any)
const AuthTestDeckIdRoute = AuthTestDeckIdRouteImport.update({
  id: '/test/$deckId',
  path: '/test/$deckId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStudyAllRoute = AuthStudyAllRouteImport.update({
  id: '/study/all',
  path: '/study/all',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStudyDeckIdRoute = AuthStudyDeckIdRouteImport.update({
  id: '/study/$deckId',
  path: '/study/$deckId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReviewDeckIdRoute = AuthReviewDeckIdRouteImport.update({
  id: '/review/$deckId',
  path: '/review/$deckId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDecksDeckIdRoute = AuthDecksDeckIdRouteImport.update({
  id: '/decks/$deckId',
  path: '/decks/$deckId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDecksDeckIdPreviewRoute = AuthDecksDeckIdPreviewRouteImport.update({
  id: '/decks/$deckId_/preview',
  path: '/decks/$deckId/preview',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthDashboardRoute
  '/public': typeof AuthPublicRoute
  '/username': typeof AuthUsernameRoute
  '/callback': typeof PublicCallbackRoute
  '/login': typeof PublicLoginRoute
  '/decks/$deckId': typeof AuthDecksDeckIdRoute
  '/review/$deckId': typeof AuthReviewDeckIdRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/study/$deckId': typeof AuthStudyDeckIdRoute
  '/study/all': typeof AuthStudyAllRoute
  '/test/$deckId': typeof AuthTestDeckIdRoute
  '/u/$username': typeof PublicUUsernameRoute
  '/decks/': typeof AuthDecksIndexRoute
  '/decks/$deckId/preview': typeof AuthDecksDeckIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthDashboardRoute
  '/public': typeof AuthPublicRoute
  '/username': typeof AuthUsernameRoute
  '/callback': typeof PublicCallbackRoute
  '/login': typeof PublicLoginRoute
  '/decks/$deckId': typeof AuthDecksDeckIdRoute
  '/review/$deckId': typeof AuthReviewDeckIdRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/study/$deckId': typeof AuthStudyDeckIdRoute
  '/study/all': typeof AuthStudyAllRoute
  '/test/$deckId': typeof AuthTestDeckIdRoute
  '/u/$username': typeof PublicUUsernameRoute
  '/decks': typeof AuthDecksIndexRoute
  '/decks/$deckId/preview': typeof AuthDecksDeckIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/public': typeof AuthPublicRoute
  '/_auth/username': typeof AuthUsernameRoute
  '/_public/callback': typeof PublicCallbackRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/decks/$deckId': typeof AuthDecksDeckIdRoute
  '/_auth/review/$deckId': typeof AuthReviewDeckIdRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_auth/study/$deckId': typeof AuthStudyDeckIdRoute
  '/_auth/study/all': typeof AuthStudyAllRoute
  '/_auth/test/$deckId': typeof AuthTestDeckIdRoute
  '/_public/u/$username': typeof PublicUUsernameRoute
  '/_auth/decks/': typeof AuthDecksIndexRoute
  '/_auth/decks/$deckId_/preview': typeof AuthDecksDeckIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/public'
    | '/username'
    | '/callback'
    | '/login'
    | '/decks/$deckId'
    | '/review/$deckId'
    | '/settings/profile'
    | '/study/$deckId'
    | '/study/all'
    | '/test/$deckId'
    | '/u/$username'
    | '/decks/'
    | '/decks/$deckId/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/public'
    | '/username'
    | '/callback'
    | '/login'
    | '/decks/$deckId'
    | '/review/$deckId'
    | '/settings/profile'
    | '/study/$deckId'
    | '/study/all'
    | '/test/$deckId'
    | '/u/$username'
    | '/decks'
    | '/decks/$deckId/preview'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_auth/dashboard'
    | '/_auth/public'
    | '/_auth/username'
    | '/_public/callback'
    | '/_public/login'
    | '/_auth/decks/$deckId'
    | '/_auth/review/$deckId'
    | '/_auth/settings/profile'
    | '/_auth/study/$deckId'
    | '/_auth/study/all'
    | '/_auth/test/$deckId'
    | '/_public/u/$username'
    | '/_auth/decks/'
    | '/_auth/decks/$deckId_/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/callback': {
      id: '/_public/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof PublicCallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/username': {
      id: '/_auth/username'
      path: '/username'
      fullPath: '/username'
      preLoaderRoute: typeof AuthUsernameRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/public': {
      id: '/_auth/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof AuthPublicRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/decks/': {
      id: '/_auth/decks/'
      path: '/decks'
      fullPath: '/decks/'
      preLoaderRoute: typeof AuthDecksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/u/$username': {
      id: '/_public/u/$username'
      path: '/u/$username'
      fullPath: '/u/$username'
      preLoaderRoute: typeof PublicUUsernameRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/test/$deckId': {
      id: '/_auth/test/$deckId'
      path: '/test/$deckId'
      fullPath: '/test/$deckId'
      preLoaderRoute: typeof AuthTestDeckIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/study/all': {
      id: '/_auth/study/all'
      path: '/study/all'
      fullPath: '/study/all'
      preLoaderRoute: typeof AuthStudyAllRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/study/$deckId': {
      id: '/_auth/study/$deckId'
      path: '/study/$deckId'
      fullPath: '/study/$deckId'
      preLoaderRoute: typeof AuthStudyDeckIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/review/$deckId': {
      id: '/_auth/review/$deckId'
      path: '/review/$deckId'
      fullPath: '/review/$deckId'
      preLoaderRoute: typeof AuthReviewDeckIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/decks/$deckId': {
      id: '/_auth/decks/$deckId'
      path: '/decks/$deckId'
      fullPath: '/decks/$deckId'
      preLoaderRoute: typeof AuthDecksDeckIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/decks/$deckId_/preview': {
      id: '/_auth/decks/$deckId_/preview'
      path: '/decks/$deckId/preview'
      fullPath: '/decks/$deckId/preview'
      preLoaderRoute: typeof AuthDecksDeckIdPreviewRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthPublicRoute: typeof AuthPublicRoute
  AuthUsernameRoute: typeof AuthUsernameRoute
  AuthDecksDeckIdRoute: typeof AuthDecksDeckIdRoute
  AuthReviewDeckIdRoute: typeof AuthReviewDeckIdRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthStudyDeckIdRoute: typeof AuthStudyDeckIdRoute
  AuthStudyAllRoute: typeof AuthStudyAllRoute
  AuthTestDeckIdRoute: typeof AuthTestDeckIdRoute
  AuthDecksIndexRoute: typeof AuthDecksIndexRoute
  AuthDecksDeckIdPreviewRoute: typeof AuthDecksDeckIdPreviewRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRoute,
  AuthPublicRoute: AuthPublicRoute,
  AuthUsernameRoute: AuthUsernameRoute,
  AuthDecksDeckIdRoute: AuthDecksDeckIdRoute,
  AuthReviewDeckIdRoute: AuthReviewDeckIdRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthStudyDeckIdRoute: AuthStudyDeckIdRoute,
  AuthStudyAllRoute: AuthStudyAllRoute,
  AuthTestDeckIdRoute: AuthTestDeckIdRoute,
  AuthDecksIndexRoute: AuthDecksIndexRoute,
  AuthDecksDeckIdPreviewRoute: AuthDecksDeckIdPreviewRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicCallbackRoute: typeof PublicCallbackRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicUUsernameRoute: typeof PublicUUsernameRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicCallbackRoute: PublicCallbackRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicUUsernameRoute: PublicUUsernameRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
